import { FilterFieldGroup } from '@App/forms/common/filter-field-group'
import { FormFieldTypes } from '@App/enum/form-field-types'
import { OverclaimFilterType } from '@App/stores/overclaim/overclaim-search-store'
import { SearchPanelSortOption } from '@Components/Search/SearchPanel/types'

// Single source of truth for the sort options, shared by the filter-sidebar radio group below
// and the SearchPanel SortBy dropdown (kept in sync via sortFilterKey="sort" on SearchPanel).
const overclaimSortValues: Array<{
    value: NonNullable<OverclaimFilterType['sort']>
    label: string
    default?: boolean
}> = [
    { value: 'overclaim_creation_date', label: 'Most Recent Overclaim', default: true },
    { value: 'documentation_due_date', label: 'Remaining Action Time' },
]

const overclaimStatusFilterGroup: FilterFieldGroup<OverclaimFilterType> = {
    name: 'Status of Overclaim',
    allowMultiple: true,
    filterFields: [
        {
            status: {
                name: 'status',
                label: '',
                type: FormFieldTypes.CHECKBOX_GROUP,
                checkboxes: [
                    {
                        id: 'OVERCLAIM',
                        label: 'Overclaim',
                    },
                    {
                        id: 'DISPUTE',
                        label: 'Dispute',
                    },
                    {
                        id: 'RESOLVED',
                        label: 'Resolved',
                    },
                    {
                        id: 'MERGED',
                        label: 'Merged',
                    },
                    {
                        id: 'CANCELED',
                        label: 'Canceled',
                    },
                ],
            },
        },
    ],
}

const overclaimSortByFilterGroup: FilterFieldGroup<OverclaimFilterType> = {
    name: 'Sort By',
    allowMultiple: false,
    filterFields: [
        {
            sort: {
                type: FormFieldTypes.RADIO,
                name: 'sort',
                options: overclaimSortValues.map(({ value, label, default: isDefault }) => ({
                    name: value,
                    label,
                    default: isDefault,
                })),
                optional: false,
                label: '',
            },
        },
    ],
}

export const overclaimSortOptions: SearchPanelSortOption[] = overclaimSortValues.map(({ value, label }) => ({
    value,
    label,
}))

const overclaimDocumentStatusFilterGroup: FilterFieldGroup<OverclaimFilterType> = {
    name: 'Document Status',
    allowMultiple: true,
    filterFields: [
        {
            documentationStatus: {
                name: 'documentationStatus',
                label: '',
                type: FormFieldTypes.CHECKBOX_GROUP,
                checkboxes: [
                    {
                        id: 'DOCUMENT_NEEDED',
                        label: 'Document Needed',
                    },
                    {
                        id: 'DOCUMENT_PENDING',
                        label: 'Document Pending Review',
                    },
                    {
                        id: 'DOCUMENT_ACCEPTED',
                        label: 'Document Accepted',
                    },
                ],
            },
        },
    ],
}

const overclaimAmendmentStatusFilterGroup: FilterFieldGroup<OverclaimFilterType> = {
    name: 'Amendment Status',
    allowMultiple: true,
    filterFields: [
        {
            amendmentStatus: {
                name: 'amendmentStatus',
                label: '',
                type: FormFieldTypes.CHECKBOX_GROUP,
                checkboxes: [
                    {
                        id: 'AMENDMENT_NEEDED',
                        label: 'Document Needed',
                    },
                    {
                        id: 'AMENDMENT_PENDING',
                        label: 'Document Pending Review',
                    },
                    {
                        id: 'AMENDMENT_ACCEPTED',
                        label: 'Document Accepted',
                    },
                ],
            },
        },
    ],
}

export const OverclaimSearchFilters: Array<FilterFieldGroup<OverclaimFilterType>> = [
    overclaimStatusFilterGroup,
    overclaimSortByFilterGroup,
    overclaimDocumentStatusFilterGroup,
    overclaimAmendmentStatusFilterGroup,
]
